(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flyexper-flight-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('[data-flyexper-form]');
      const origin = form.elements.origin;
      const destination = form.elements.destination;
      const departure = root.querySelector('[data-flyexper-departure]');
      const returnInput = root.querySelector('[data-flyexper-return]');
      const returnField = root.querySelector('[data-flyexper-return-field]');
      const error = root.querySelector('[data-flyexper-error]');
      const results = root.querySelector('[data-flyexper-results]');
      const resultList = root.querySelector('[data-flyexper-result-list]');
      const submitLabel = root.querySelector('[data-flyexper-submit-label]');
      const empty = root.querySelector('[data-flyexper-empty]');
      const mode = root.querySelector('[data-flyexper-mode]');
      const resultsTitle = root.querySelector('[data-flyexper-results-title]');
      const apiEndpoint = root.dataset.apiEndpoint.trim();
      const today = new Date().toISOString().split('T')[0];
      const phone = root.dataset.whatsapp.replace(/\D/g, '');
      const sortResults = (key) => {
        [...resultList.children]
          .sort((a, b) => Number(a.dataset[key]) - Number(b.dataset[key]))
          .forEach((item) => resultList.appendChild(item));
      };

      const airportCode = (value) => {
        const match = String(value).toUpperCase().match(/\(([A-Z]{3})\)\s*$/);
        return match ? match[1] : String(value).trim().toUpperCase();
      };

      const timeLabel = (value) => value
        ? new Intl.DateTimeFormat('az-AZ', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(value))
        : '—';

      const durationLabel = (minutes) => {
        const hours = Math.floor(Number(minutes) / 60);
        const mins = Number(minutes) % 60;
        return `${hours}s ${mins}d`;
      };

      const priceLabel = (amount, currency) => new Intl.NumberFormat('az-AZ', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2,
      }).format(Number(amount));

      const escapeHtml = (value) => String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

      const renderOffers = (offers) => {
        resultList.innerHTML = offers.map((offer) => {
          const stopLabel = offer.stops === 0 ? 'Birbaşa' : `${offer.stops} dayanacaq`;
          const flexibility = offer.refundable
            ? 'Geri qaytarıla bilər'
            : offer.changeable ? 'Dəyişdirilə bilər' : 'Məhdud tarif';
          const formattedPrice = priceLabel(offer.price, offer.currency);
          return `
            <article class="flyexper-flight" data-price="${Number(offer.price)}" data-duration="${Number(offer.durationMinutes)}" data-offer-id="${escapeHtml(offer.id)}">
              <div class="flyexper-flight__airline"><span>${escapeHtml(offer.airlineCode || '✈')}</span><div><strong>${escapeHtml(offer.airline)}</strong><small>${escapeHtml(offer.flightNumber)}</small></div></div>
              <div class="flyexper-flight__journey">
                <div><strong>${timeLabel(offer.departingAt)}</strong><span>${escapeHtml(offer.origin)}</span></div>
                <div class="flyexper-flight__line"><span>${durationLabel(offer.durationMinutes)}</span><i></i><small>${stopLabel}</small></div>
                <div><strong>${timeLabel(offer.arrivingAt)}</strong><span>${escapeHtml(offer.destination)}</span></div>
              </div>
              <div class="flyexper-flight__meta"><span>✓ ${escapeHtml(offer.baggage)}</span><span>${flexibility}</span></div>
              <div class="flyexper-flight__price"><small>FlyExper satış qiyməti</small><strong>${formattedPrice}</strong><button type="button" data-flyexper-request ${phone ? '' : 'disabled'}>Bu bileti istəyirəm</button></div>
            </article>`;
        }).join('');
      };

      departure.min = today;
      returnInput.min = today;

      root.querySelector('[data-flyexper-swap]').addEventListener('click', () => {
        const current = origin.value;
        origin.value = destination.value;
        destination.value = current;
      });

      form.addEventListener('change', (event) => {
        if (event.target.name.startsWith('trip_type_')) {
          const isOneWay = event.target.value === 'oneway';
          returnField.hidden = isOneWay;
          returnInput.required = !isOneWay;
          if (isOneWay) returnInput.value = '';
        }
        if (event.target === departure) {
          returnInput.min = departure.value || today;
          if (returnInput.value && returnInput.value < departure.value) returnInput.value = '';
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        error.hidden = true;
        if (!form.checkValidity()) {
          error.hidden = false;
          form.reportValidity();
          return;
        }

        if (!apiEndpoint) {
          error.textContent = 'Uçuş API ünvanı hələ qoşulmayıb.';
          error.hidden = false;
          return;
        }

        form.classList.add('is-loading');
        submitLabel.textContent = root.dataset.loadingLabel;
        resultList.innerHTML = '';
        empty.hidden = true;
        try {
          const tripType = form.querySelector('input[name^="trip_type_"]:checked').value;
          const response = await fetch(apiEndpoint, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
              origin: airportCode(origin.value),
              destination: airportCode(destination.value),
              departureDate: departure.value,
              returnDate: tripType === 'roundtrip' ? returnInput.value : '',
              passengers: Number(form.elements.passengers.value),
              cabinClass: form.elements.cabin.value,
            }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.error || 'Axtarış zamanı xəta baş verdi.');

          mode.textContent = payload.testMode ? 'Duffel test nəticələri' : 'Canlı nəticələr';
          resultsTitle.textContent = `${payload.offers.length} uçuş təklifi tapıldı`;
          renderOffers(payload.offers);
          if (!payload.offers.length) {
            empty.textContent = 'Bu istiqamət və tarix üçün uçuş təklifi tapılmadı.';
            empty.hidden = false;
          }
          results.hidden = false;
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (requestError) {
          error.textContent = requestError.message || 'Axtarış zamanı xəta baş verdi.';
          error.hidden = false;
        } finally {
          form.classList.remove('is-loading');
          submitLabel.textContent = root.dataset.searchLabel;
        }
      });

      root.querySelector('[data-flyexper-sort]').addEventListener('change', (event) => {
        sortResults(event.target.value);
      });

      resultList.addEventListener('click', (event) => {
        const button = event.target.closest('[data-flyexper-request]');
        if (!button || !phone) return;
        const card = button.closest('.flyexper-flight');
        const airline = card.querySelector('.flyexper-flight__airline strong').textContent.trim();
        const price = card.querySelector('.flyexper-flight__price strong').textContent.trim();
        const flightNumber = card.querySelector('.flyexper-flight__airline small').textContent.trim();
        const offerId = card.dataset.offerId;
        const message = `Salam, ${origin.value} → ${destination.value} istiqamətində ${airline} ${flightNumber} uçuşu ilə maraqlanıram. Saytda göstərilən qiymət: ${price}. Təklif kodu: ${offerId}. Zəhmət olmasa qiyməti və mövcudluğu təsdiqləyin.`;
        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
      });
    };

    document.querySelectorAll('[data-flyexper-search]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-flyexper-search]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
